// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProgressBarCell {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.ProgressBarCell-Bar {
  flex: 1 1 auto;
  min-width: 0;
}
.ProgressBarCell-Bar .progress {
  height: 0.5rem;
  margin: 0;
  border-radius: 50rem;
}
.ProgressBarCell-Bar .progress-bar {
  border-radius: 50rem;
  background-color: var(--progress-color, var(--bs-progress-bar-bg));
}
.ProgressBarCell-Label {
  flex: 0 0 3rem;
  text-align: right;
  white-space: nowrap;
  font-size: 0.875rem;
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/pages/Reports/DynamicReport/components/ReportTable/components/ProgressBarCell/styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AACF;AACE;EACE,cAAA;EACA,YAAA;AACJ;AACI;EACE,cAAA;EACA,SAAA;EACA,oBAAA;AACN;AAEI;EACE,oBAAA;EACA,kEAAA;AAAN;AAIE;EACE,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AAFJ","sourcesContent":[".ProgressBarCell {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n\n  &-Bar {\n    flex: 1 1 auto;\n    min-width: 0;\n\n    .progress {\n      height: 0.5rem;\n      margin: 0;\n      border-radius: 50rem;\n    }\n\n    .progress-bar {\n      border-radius: 50rem;\n      background-color: var(--progress-color, var(--bs-progress-bar-bg));\n    }\n  }\n\n  &-Label {\n    flex: 0 0 3rem;\n    text-align: right;\n    white-space: nowrap;\n    font-size: 0.875rem;\n    font-weight: 600;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
